import { DashboardCard } from '@/common/dashboard/DashboardCard';
import { DimTree } from '@/common/entityFramework/entityPerspective/support/DimTree';
import { MainBox } from '@/common/layout/MainBox';
import { Spacer, SpacerLayout } from '@/common/layout/SpacerLayout';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { Title } from '@/common/title/Title';
import { TreeUtils } from '@/common/utils/TreeUtils';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { Box, MenuItem, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { AbvMediShaGrid } from './charts/AbvMediShaGrid';
import { AbvMediShaLineChart } from './charts/AbvMediShaLineChart';
import { AbvMediShaTopFiveLineChart } from './charts/AbvMediShaTopFiveLineChart';

export const AbvMediShaDashboard = () => {

  const [periods, setPeriods] = useState([]); // safe default so .map doesn't explode
  const [prodTree, setProdTree] = useState();

  const [stateTree, setStateTree] = useState();
  const [stateIds, setStateIds] = useState();

  const [startPeriod, setStartPeriod] = useState();
  const [endPeriod, setEndPeriod] = useState();

  const [prodIds, setProdIds] = useState();

  const rsrc = useRsrc();

  useEffect(() => {
    rsrc.data('gtn', 'MEDI_SHA_DASHBOARD_FILTERS_DATA_PLUGIN').then((res) => {
  
      setPeriods(res.periods);

      const startPeriod = res.periods[0];
      setStartPeriod(startPeriod);

      const endPeriod = res.periods[res.periods.length - 1];
      setEndPeriod(endPeriod);

      setProdTree(res.prodTree);
      const processed = TreeUtils.parseTree(res.prodTree).leafIds;
      setProdIds(processed);

      setStateTree(res.stateTree);
      const processedState = TreeUtils.parseTree(res.stateTree).leafIds;
      setStateIds(processedState);

    });
  }, []);

  if (!prodIds) return null;

  return (
    <MainBox>
      {/* Title */}
      <Box sx={{ mb: 1 }}>
        <Title icon={fas.faChartLine} title="Medicaid SHA Dashboard" />
      </Box>

      {/* Filters */}
      <Box sx={{ mb: 2, display: 'flex', gap: 2 }}>
        <TextField
          fullWidth
          select
          variant="outlined"
          label="Start Period"
          value={startPeriod ?? ''}
          onChange={(event) => setStartPeriod(event.target.value)}
        >
          {(periods ?? []).map((periodValue) => (
            <MenuItem key={periodValue} value={periodValue}>
              {periodValue}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          fullWidth
          select
          variant="outlined"
          label="End Period"
          value={endPeriod ?? ''}
          onChange={(event) => setEndPeriod(event.target.value)}
        >
          {(periods ?? []).map((periodValue) => (
            <MenuItem key={periodValue} value={periodValue}>
              {periodValue}
            </MenuItem>
          ))}
        </TextField>

        <DimTree
          displayName="Product"
          treeData={prodTree}
          selectedIds={prodIds}
          onFilterChange={(ids) => setProdIds(ids)}
        />

        <DimTree
          displayName="State"
          treeData={stateTree}
          selectedIds={stateIds}
          onFilterChange={(ids) => setStateIds(ids)}
        />
      </Box>

      <SpacerLayout>
        <Spacer vertical weights={[1, 1]}>
          <Spacer weights={[1, 1]}>
            <DashboardCard title="Total Medicaid TRx Trend (All States)">
              <AbvMediShaLineChart
                startPeriod={startPeriod}
                endPeriod={endPeriod}
                prodIds={prodIds}
                stateIds={stateIds}
              />
            </DashboardCard>
            <DashboardCard title="Total Medicaid TRx Trend - 5 Top States by Volume">
              <AbvMediShaTopFiveLineChart
                startPeriod={startPeriod}
                endPeriod={endPeriod}
                prodIds={prodIds}
                stateIds={stateIds}
              />
            </DashboardCard>
          </Spacer>
          <Spacer>
            <DashboardCard title="Medicaid SHA Grid">
              <AbvMediShaGrid
                endPeriod={endPeriod}
                prodIds={prodIds}
                stateIds={stateIds}
              />
            </DashboardCard>
          </Spacer>
        </Spacer>
      </SpacerLayout>
      
    </MainBox>
  );
};